import React from 'react';

export const mockEvent = {
  currentTarget: {},
} as React.ChangeEvent<HTMLInputElement>;
